import type { ErrorInfo } from 'react';
import {
    captureMessage,
    captureException,
    captureReactException,
} from '@sentry/gatsby';

export function sentryMessage(message: string): void {
    captureMessage(message);

    if (!process.env.GATSBY_SENTRY_DSN) {
        // eslint-disable-next-line no-console
        console.warn(
            `Sentry was not configured. Unable to send message: ${message}`,
        );
    }
}

export function sentryException(error: unknown): void {
    captureException(error);

    if (!process.env.GATSBY_SENTRY_DSN) {
        // eslint-disable-next-line no-console
        console.warn(
            `Sentry was not configured. Unable to send error: ${error}`,
        );
    }
}

/**
 * Like `sentryException`, for errors React reports while rendering, with the
 * component stack of where they happened.
 */
export function sentryReactException(
    error: unknown,
    errorInfo: ErrorInfo,
): void {
    captureReactException(error, errorInfo);

    if (!process.env.GATSBY_SENTRY_DSN) {
        // eslint-disable-next-line no-console
        console.warn(
            `Sentry was not configured. Unable to send error: ${error}`,
        );
    }
}
